import { Component } from "react";

import { withRouter } from "react-router-dom";
import TitleBar from "../../components/ui/TitleBar";

import "./style.scss";
import EditImage from "../../components/EditImage";
import { TabView, TabItem } from "../../components/TabView";
import Input from "../../components/ui/Input";
import CheckBox from "../../components/ui/CheckBox";
import ColorPicker from "../../components/ui/ColorPicker";
import Select from "../../components/ui/Select";
import Alignment from "../../components/ui/Alignment";
import RectButton from "../../components/ui/button/RectButton";
import TitleSeparator from "../../components/ui/TitleSeparator";
import AppContext from "../../contexts/AppContext";
import SaveCardPopup from "../../components/Popup/SaveCardPopup";
import Option from "../../components/ui/Select/Option";

class Customizable extends Component {
    static contextType = AppContext;

    state = {
        outsideImage: null,
        outsideZoom: 1,
        headerWritingStyle: null,
        headerText: "",
        headerFontSize: 20,
        headerColor: null,
        headerTextAlign: "center",
        headerImage: null,
        headerZoom: null,
        footerWritingStyle: null,
        footerText: "",
        footerFontSize: 20,
        footerColor: null,
        footerTextAlign: "center",
        footerImage: null,
        footerZoom: null,
        tabPage: 0,
        showHeaderEditor: false,
        showFooterEditor: false,
    }

    componentDidUpdate() {
        if (this.state.showHeaderEditor || this.state.showFooterEditor) {
            this.setState({ showHeaderEditor: false, showFooterEditor: false });
        }
    }

    onHeaderhandler = () => {
        this.setState({ tabPage: 0, showHeaderEditor: true });
    }

    onFooterHandler = () => {
        this.setState({ tabPage: 1, showFooterEditor: true });
    }

    render() {
        let outsideCustom =
            <section className="outside-custom" key="custom-1">
                <TitleBar title="Front Customization" />
                <div className="box">
                    <p>Change out the front design with a photo or image</p>
                    <EditImage text={<><span>Recommended resolution: </span><span>2025 x 1425</span></>} onImageSelect={(image) => this.setState({ outsideImage: image })} onZoomChange={(value) => this.setState({ outsideZoom: value })} />
                </div>
            </section>
        let insideCustomization =
            <section className="inside-customization" key="custom-2">
                <TitleBar title="Back Customization" />
                <div className="box no-padding">
                    <TabView onPageChange={(page) => this.setState({ tabPage: page })} page={this.state.tabPage}>
                        <TabItem className={!this.state.tabPage ? "" : "hide"} title="HEADER">
                            <div className="row lock"><Input placeHolder="Your Text" key="text-header" value={this.state.headerText} onChange={(value) => this.setState({ headerText: value })} /></div>
                            <div className="row lock">
                                <Select className={`font-name ${this.state.headerWritingStyle ? `${this.state.headerWritingStyle} selected` : ""}`} onChange={(e) => this.setState({ headerWritingStyle: e.currentTarget.value })}>
                                    <Option hidden={true} defaultValue={true}>Select Font</Option>
                                    {
                                        this.context.fonts.map((item, i) => {
                                            return <Option className={item.className} value={item.className} key={`font-opt-${i}-header`}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                <Select className="text-size" onChange={(e) => this.setState({ headerFontSize: e.currentTarget.value })}>
                                    {[...Array(31)].map((e, i) => {
                                        return <Option value={i + 20} key={`font-size-${i}-header`}>{i + 20}</Option>
                                    })}
                                </Select>
                                <CheckBox className="lock-font-size" label="Lock Font Size" />
                            </div>
                            <div className="row lock">
                                <ColorPicker key="colorpicker-header" text="Header Text Color" onColorChange={(color) => this.setState({ headerColor: color })} />
                                <Alignment onAlignChange={(value) => {
                                    switch (value) {
                                        case 0: this.setState({ headerTextAlign: "flex-start" }); break;
                                        case 1: this.setState({ headerTextAlign: "center" }); break;
                                        case 2: this.setState({ headerTextAlign: "flex-end" }); break;
                                        default:
                                    }
                                }} />
                            </div>
                            <div className="column">
                                <TitleSeparator title="OR ADD YOUR LOGO" />
                                <EditImage text={<><span>Recommended resolution: </span><span>2025 x 1425</span></>} onImageSelect={(image) => this.setState({ headerImage: image })} onZoomChange={(value) => this.setState({ headerZoom: value })} show={this.state.showHeaderEditor} />
                            </div>
                        </TabItem>
                        <TabItem className={this.state.tabPage === 1 ? "" : "hide"} title="FOOTER">
                            <div className="row lock"><Input placeHolder="Your Text" value={this.state.footerText} onChange={(value) => this.setState({ footerText: value })} /></div>
                            <div className="row lock">
                                <Select className={`font-name ${this.state.footerWritingStyle ? `${this.state.footerWritingStyle} selected` : ""}`} onChange={(e) => this.setState({ footerWritingStyle: e.currentTarget.value })}>
                                    <Option hidden={true} defaultValue={true}>Select Font</Option>
                                    {
                                        this.context.fonts.map((item, i) => {
                                            return <Option className={item.className} value={item.className} key={`font-opt-${i}-header`}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                <Select className="text-size" onChange={(e) => this.setState({ footerFontSize: e.currentTarget.value })}>
                                    {[...Array(31)].map((e, i) => {
                                        return <Option value={i + 20} key={`font-size-${i}-footer`}>{i + 20}</Option>
                                    })}
                                </Select>
                            </div>
                            <div className="row lock">
                                <ColorPicker key="colorpicker-footer" text="Footer Text Color" onColorChange={(color) => this.setState({ footerColor: color })} />
                                <Alignment onAlignChange={(value) => {
                                    switch (value) {
                                        case 0: this.setState({ footerTextAlign: "flex-start" }); break;
                                        case 1: this.setState({ footerTextAlign: "center" }); break;
                                        case 2: this.setState({ footerTextAlign: "flex-end" }); break;
                                        default:
                                    }
                                }} />
                            </div>
                            <div className="column">
                                <TitleSeparator title="OR ADD YOUR LOGO" />
                                <EditImage text={<><span>Recommended resolution: </span><span>2025 x 1425</span></>} onImageSelect={(image) => this.setState({ footerImage: image })} onZoomChange={(value) => this.setState({ footerZoom: value })} show={this.state.showFooterEditor} />
                            </div>
                        </TabItem>
                    </TabView>
                </div>
            </section>
        // let saveCardBt = <RectButton text="SAVE CARD" key="custom-5" onClick={() => this.context.setPopup(<SaveCardPopup />)} />
        let outsidePreview =
            <section className="outside-preview" key="custom-3">
                <TitleBar title="Card Front Preview" />
                <div className="box no-padding">
                    <div className="image-selected">{this.state.outsideImage ? <img src={this.state.outsideImage} style={{ transform: `scale(${this.state.outsideZoom})` }} alt="Outside Preview" /> : "No image"}</div>
                </div>
            </section>
        let insidePreview =
            <section className="inside-preview" key="custom-4">
                <TitleBar title="Card Back Preview" />
                <div className="box column">
                    <div className="container">
                        <div className="content">
                            <div className="header" style={{ justifyContent: this.state.headerTextAlign }} onClick={this.onHeaderhandler}>
                                {
                                    this.state.headerImage ? <img src={this.state.headerImage} alt="Header" style={{ transform: `scale(${this.state.headerZoom})` }} /> :
                                        <span className={`${this.state.headerWritingStyle ? `${this.state.headerWritingStyle} selected` : ""}`} style={{ fontSize: `${parseInt(this.state.headerFontSize) / ((this.state.headerWritingStyle && this.state.headerWritingStyle.indexOf("big") > -1) ? 15 : 25.71)}rem`, color: this.state.headerColor }}>{this.state.headerText || "Header / Logo"}</span>
                                }
                            </div>
                            <div className="message"><span>Hello!</span>
                                <span>This is a sample Handwrytten message to show you where your message will appear. Don't worry, this will not show up on your custom card.</span>
                                <span>Wryte On!</span>
                                <span>The Handwrytten Robot</span></div>
                            <div className="footer" style={{ justifyContent: this.state.footerTextAlign }} onClick={this.onFooterHandler}>
                                {
                                    this.state.footerImage ? <img src={this.state.footerImage} alt="Footer" style={{ transform: `scale(${this.state.footerZoom})` }} /> :
                                        <span className={`${this.state.footerWritingStyle ? `${this.state.footerWritingStyle} selected` : ""}`} style={{ fontSize: `${parseInt(this.state.footerFontSize) / ((this.state.footerWritingStyle && this.state.footerWritingStyle.indexOf("big") > -1) ? 15 : 25.71)}rem`, color: this.state.footerColor }}>{this.state.footerText || "Footer"}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        return (
            <>
                <div className="full-container customizable">
                    <div className="section-box row">
                        {[outsideCustom, outsidePreview]}
                    </div>
                    <div className="section-box row">
                        {[insideCustomization, insidePreview]}
                    </div>
                    <div className="section-box">
                        <RectButton text="SAVE CARD" key="custom-5" onClick={() => this.context.setPopup(<SaveCardPopup />)} />
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(Customizable);